/* Built In Imports */
/* External Imports */
import { Box, Icon } from '@chakra-ui/react';

/* Internal Imports */
/* Components */

/* Services */
/* Styles */
export const SpeakerIcon = ({ width, height, color }) => {
  return (
    <Icon
      width={width || { base: '23px', md: '24px' }}
      height={height || { base: '23px', md: '24px' }}
      viewBox={{ base: '0 0 23px 23px', md: '0 0 24px 24px' }}
      fill="none"
      color={color}
    >
      <path
        d="M18.2758 4.72226C20.01 6.4565 21.0827 8.85233 21.0827 11.4987C21.0827 14.1451 20.01 16.5409 18.2758 18.2751M15.2264 7.77166C16.1802 8.72549 16.7702 10.0432 16.7702 11.4987C16.7702 12.9542 16.1802 14.2719 15.2264 15.2257M1.91602 7.66536H5.74935L11.4993 4.55078V18.4466L5.74935 15.332H1.91602V7.66536Z"
        stroke={color || '#0E1216'}
        stroke-width="0.953488"
      />
    </Icon>
  );
};

export const VideoIcon = ({ width, height, pt, color }) => {
  return (
    <Box pt={pt || '18.81px'}>
      <Icon width={width || '24px'} height={height || 25} fill="none">
        <path
          d="M3.21191 5.67969H14.8962V19.3113H3.21191V5.67969Z"
          stroke={color || '#0E1216'}
          stroke-width="0.953488"
        />
        <path
          d="M14.8962 10.5481L20.7383 7.62706V17.3639L14.8962 14.4429V10.5481Z"
          stroke={color || '#0E1216'}
          stroke-width="0.953488"
        />
      </Icon>
    </Box>
  );
};

export const ArticleIcon = ({ width, height, pt, color }) => {
  return (
    <Box pt={pt || '18.81px'}>
      <Icon
        width={width || '20px'}
        height={height || 20}
        fill="none"
        color={color}
      >
        <path
          d="M4.29134 4.6224H9.70801M4.29134 7.95573H9.70801M4.29134 11.2891H6.37467M0.958008 1.28906H13.0413V16.7057H0.958008V1.28906Z"
          stroke={color || '#0E1216'}
          stroke-width="1.5"
          strokeLinecap="square"
        />
      </Icon>
    </Box>
  );
};

export const AudioIcon = ({ width, height, pt, color }) => {
  return (
    <Box pt={pt || '18.81px'}>
      <Icon
        width={width || '24px'}
        height={height || 25}
        viewBox={`0 0 24px 25px`}
        fill="none"
      >
        <path
          d="M10.0257 18.9085C10.0257 20.2529 8.71791 21.3428 7.10465 21.3428C5.4914 21.3428 4.18359 20.2529 4.18359 18.9085C4.18359 17.5642 5.4914 16.4743 7.10465 16.4743C8.71791 16.4743 10.0257 17.5642 10.0257 18.9085ZM10.0257 18.9085V6.73747L19.7626 3.81641V15.9875M19.7626 15.9875C19.7626 17.3319 18.4548 18.4217 16.8415 18.4217C15.2283 18.4217 13.9205 17.3319 13.9205 15.9875C13.9205 14.6431 15.2283 13.5533 16.8415 13.5533C18.4548 13.5533 19.7626 14.6431 19.7626 15.9875Z"
          stroke={color || '#0E1216'}
          stroke-width="0.953488"
        />
      </Icon>
    </Box>
  );
};
